import React from 'react';
import { TESTIDS } from '@/lib/testIds';
import { Instagram, Facebook } from 'lucide-react';

const LOGO_URL = '/images/logo.png';

export default function Footer() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };
  return (
    <footer
      data-testid={TESTIDS.footer.section}
      className="relative bg-[#24385C] text-[#FBF7F2] pt-20 pb-10 overflow-hidden"
    >
      {/* soft wash */}
      <div className="absolute -top-20 -left-20 w-96 h-96 bg-[#8D68B2]/25 blob-shape-1" />
      <div className="absolute -bottom-24 -right-20 w-[420px] h-[420px] bg-[#B88ACB]/20 blob-shape-2" />

      <div className="max-w-6xl mx-auto px-6 md:px-12 relative">
        <div className="grid md:grid-cols-3 gap-10 items-start">
          <div className="flex items-start gap-4">
            <div className="bg-white rounded-2xl p-2 shadow-md">
              <img src={LOGO_URL} alt="Erica Thayer" className="h-16 w-16 object-contain" />
            </div>
            <div>
              <div className="font-heading text-2xl">Erica Thayer</div>
              <div className="font-accent text-2xl text-[#F5C857] -mt-1">Stories for Growing Hearts</div>
            </div>
          </div>

          <div>
            <p className="font-body font-semibold uppercase tracking-widest text-xs text-[#F5C857]">Explore</p>
            <ul className="mt-4 space-y-2 font-body">
              <li><button onClick={() => scrollTo('about')} className="hover:text-[#F5C857] transition-colors">About Erica</button></li>
              <li><button onClick={() => scrollTo('book')} className="hover:text-[#F5C857] transition-colors">The Feelings Bench</button></li>
              <li><button onClick={() => scrollTo('resources')} className="hover:text-[#F5C857] transition-colors">Resources</button></li>
              <li><button onClick={() => scrollTo('contact')} className="hover:text-[#F5C857] transition-colors">Contact</button></li>
            </ul>
          </div>

          <div>
            <p className="font-body font-semibold uppercase tracking-widest text-xs text-[#F5C857]">Say hello</p>
            <div className="mt-4 flex gap-3">
              <a
                data-testid={TESTIDS.footer.instagram}
                href="#"
                aria-label="Instagram"
                className="w-11 h-11 rounded-full bg-white/10 hover:bg-[#F5C857] hover:text-[#24385C] flex items-center justify-center transition-all"
              >
                <Instagram size={18} strokeWidth={1.8} />
              </a>
              <a
                data-testid={TESTIDS.footer.facebook}
                href="#"
                aria-label="Facebook"
                className="w-11 h-11 rounded-full bg-white/10 hover:bg-[#F5C857] hover:text-[#24385C] flex items-center justify-center transition-all"
              >
                <Facebook size={18} strokeWidth={1.8} />
              </a>
            </div>
            <p className="mt-4 font-accent text-xl text-[#FBF7F2]/90">
              Come find us in the garden.
            </p>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/15 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-body text-sm text-[#FBF7F2]/70">
            © {new Date().getFullYear()} Erica Thayer. Made with kindness, curiosity, and a very small bee.
          </p>
          <p className="font-accent text-xl text-[#F5C857]">Every feeling belongs. 💜</p>
        </div>
      </div>
    </footer>
  );
}
